/**
 * @generated SignedSource<<806fa1587df4d28bdc3ee36ba5f35eed>>
 * @relayHash 4f04a47a096ee41c3312f024f459983a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29399780a8a644c3c7767e4f17ccbc6be94478c83e574039500f0a7b45410046

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type issueDetailsForAIContextPanelQuery$variables = {
  cloudId: string;
  includeContextPanelState: boolean;
  issueKey: string;
};
export type issueDetailsForAIContextPanelQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly fieldByIdOrAlias: {
        readonly text?: string | null | undefined;
      } | null | undefined;
      readonly issueId: string;
      readonly projectField: {
        readonly project: {
          readonly isAIEnabled: boolean | null | undefined;
          readonly isAiContextFeatureEnabled?: boolean | null | undefined;
          readonly projectId: string | null | undefined;
          readonly projectType: JiraProjectType | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type issueDetailsForAIContextPanelQuery = {
  response: issueDetailsForAIContextPanelQuery$data;
  variables: issueDetailsForAIContextPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeContextPanelState"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v5 = [
  {
    "kind": "Literal",
    "name": "idOrAlias",
    "value": "servicedesk-practices"
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
},
v7 = {
  "kind": "ScalarField",
  "name": "isAIEnabled"
},
v8 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v9 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v10 = {
  "condition": "includeContextPanelState",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAiContextFeatureEnabled"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueDetailsForAIContextPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "fieldByIdOrAlias",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
              },
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueDetailsForAIContextPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "fieldByIdOrAlias",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
              },
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ]
                  },
                  (v11/*: any*/)
                ]
              },
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "29399780a8a644c3c7767e4f17ccbc6be94478c83e574039500f0a7b45410046",
    "metadata": {},
    "name": "issueDetailsForAIContextPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c79cbdb15ebd8cd407d3b4dc36105504";

export default node;
